import { SOGetSimpleAttribute } from '../simple-attribute/so-get-simple-attribute';
import { SOGetProject } from '../project/so-get-project';
import { SOGetOrganization } from '../organization/so-get-organization';
import {ENAttributePermissionType} from '../../enums';


export class SOPostSimpleAttributePermission {

  constructor(
    public name: string,
    public whiteList: boolean,
    public permissionType: ENAttributePermissionType,
    public project: SOGetProject,
    public organization: SOGetOrganization,
    public description: string = "",
    public simpleAttribute: SOGetSimpleAttribute = null,
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOPostSimpleAttributePermission(
      'name' in params ? params.name : null,
      'description' in params ? params.description : null,
      'whiteList' in params ? params.whiteList : null,
      'permissionType' in params ? params.permissionType : null,
      'simpleAttribute' in params ? params.simpleAttribute : null,
      'project' in params ? params.project : null,
      'organization' in params ? params.organization : null,
    );
  }
}
